import React from "react";
import { useNavigate } from "react-router-dom";

export default function MainScreen() {
  const nav = useNavigate();

  return (
    <div style={{ padding: 16 }}>
      <h2>Main Menu</h2>

      <div style={{ display: "flex", gap: 12, marginTop: 12 }}>
        <button onClick={() => nav("/setup")}>New Campaign</button>
        <button onClick={() => nav("/load")}>Load Campaign</button>
        <button onClick={() => nav("/dashboard")}>Campaign Dashboard</button>
      </div>

      <p style={{ marginTop: 16, opacity: 0.8 }}>
        New Campaign starts in Campaign Setup, where you’ll name the settlement and pick the campaign type.
      </p>
    </div>
  );
}